import PropTypes from "prop-types";
import React from "react";

import Header from "./Header";
import Footer from "./Footer";
function Layout({ children }) {

  return (
    <>
      <Header />

      <main className="">
        {children}
      </main>
      
      <Footer />
    </>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;